import { FC, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../../custom-hooks/useAppDispatch";
import { useSelector } from "react-redux";
import { WorkServiceImpl } from "../../../../services/WorkServiceImpl";
import { DEFAULT_OFFSET, DEFAULT_PAGE, RECORDS_PER_PAGE } from "../../../../domain/constants";
import WorkList from "./work-list/WorkList";
import CustomError from "../../../../custom-components/form-inputs/CustomError";
import { selectInterestingWorks } from "../../../../slices/promotion-works-slice";
import { WorkListType } from "../../../../domain/models/Work";
import { getUserCoords, selectUser } from "../../../../slices/user-slice";

const InterestingVacancies: FC = () => {
    const [errorKey, setErrorKey] = useState("");
    const [page, setPage] = useState(0);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();

    const user = useSelector(selectUser());
    const interestingWorks = useSelector(selectInterestingWorks);

    const uploadWorks = async (resetPage: boolean) => {
        const currentPage = resetPage ? DEFAULT_PAGE : page + 1;
        const result = await dispatch(
            WorkServiceImpl.getInterestingWorksThunk({
                page: currentPage,
                limit: RECORDS_PER_PAGE,
                offset: DEFAULT_OFFSET,
                coords: await getUserCoords(user),
            })
        );
        if (result.meta.requestStatus !== "fulfilled") {
            setErrorKey("errors.common");
        }
        setPage(currentPage);
    };

    const uploadWorksCallback = useCallback(async () => {
        uploadWorks(false);
    }, [page]);

    // if (_.isEmpty(interestingWorks.rows)) return <></>;

    return (
        <>
            <h2 className="H32B dmax2:H24B text-textWhite mb-10 dmax2:mb-6">
                {t("applications.interestingVacancies")}
            </h2>
            <WorkList
                type={WorkListType.INTERESTING_WORKS}
                altWorks={interestingWorks}
                uploadWorksCallback={uploadWorksCallback}
                wrapClassName="dmin2:w-[845px]"
            />
            <CustomError errorKey={errorKey} />
        </>
    );
};

export default InterestingVacancies;
